

const Support = () => {
  const styles = {
    color: "#0f172a",
  };
  const styles1 = {
    color: "black",
  };

  return (
    <div>
      <div className="leftContainer page_layout" style={styles}>
        <div className="support-portal-container">
          <div className="support-hero-section">
            <div className="hero-text">
              <h2 className="fade-in-title">Help Center</h2>
              <p>Got a question? We're available 24/7 to assist you.</p>
            </div>
            <div className="hero-visual">
              <img
                src="./images/support.jpg"
                alt="Support"
                className="hero-avatar"
              />
            </div>
          </div>

          <div className="support-content-body">
            <div className="section-divider">
              <span style={{ ...styles1 }}>
                Contact Us At Below Platforms.
              </span>
            </div>

            <div className="contact-grid-layout">
              {JSON.parse(localStorage.getItem("sitSetting"))
                ?.whatsappSupport && (
                <a
                  className="contact-tile whatsapp-tile"
                  href={
                    JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="tile-icon-box">
                    <img src="/images/whatsapp.png" alt="WhatsApp" />
                  </div>
                  <div className="tile-details">
                    <h4>WhatsApp Chat</h4>
                    <p>Instant reply within minutes</p>
                  </div>
                  <div className="tile-arrow">→</div>
                </a>
              )}

              <a
                className="contact-tile email-tile"
                href="mailto:support@example.com"
              >
                <div className="tile-icon-box">
                  <img src="./images/mail.png" alt="Email" />
                </div>
                <div className="tile-details">
                  <h4>Email Support</h4>
                  <p>Get professional assistance</p>
                </div>
                <div className="tile-arrow">→</div>
              </a>
            </div>

          </div>
        </div>
      </div>
     
    </div>
  );
};

export default Support;
